import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../utils/helper";

export const authServerApi = createApi({
  reducerPath: "authServerApi",
  baseQuery: fetchBaseQuery({ baseUrl: process?.env?.REACT_APP_API_HOST_URL }),
  tagTypes: ["Auth"],
  endpoints: (builder) => ({
    isAuthUser: builder.query({
      query: () => ({
        url: "/isAuthorized",
        headers: getHeaders(),
      }),
      providesTags: ["Auth"],
    }),
    getUserProfile: builder.query({
      query: () => ({
        url: "/users/profile",
        headers: getHeaders(),
      }),
      providesTags: ["Auth"],
    }),
    getCompanyNumber: builder.query({
      query: () => ({
        mode: "cors",
        url: `/core/company/${process?.env?.REACT_APP_COMPANY}`,
        headers: getHeaders(),
      }),
      providesTags: ["Auth"],
    }),
    login: builder.mutation({
      query: (body) => ({
        url: "login",
        method: "POST",
        body: {
          ...body,
          companyNo: ~~sessionStorage.getItem("companyNo"),
          sessionTimeoutInMin: 1440, // 24 hours
        },
      }),
      invalidatesTags: ["Auth"],
    }),
    registerUser: builder.mutation({
      query: (body) => ({
        url: "/users/register",
        method: "POST",
        headers: getHeaders(),
        body: { ...body },
      }),
      invalidatesTags: ["Auth"],
    }),
    forgotPassword: builder.mutation({
      query: (email) => ({
        method: "GET",
        url: `/users/${email}/credentials/forgot_password`,
        headers: getHeaders(),
      }),
      invalidatesTags: ["Auth"],
    }),
    validateToken: builder.mutation({
      query: (jwtToken) => ({
        method: "GET",
        url: `/users/credentials/token_validate`,
        headers: { jwtToken },
      }),
      invalidatesTags: ["Auth"],
    }),
    changePassword: builder.mutation({
      query: (body) => ({
        url: "/users/credentials/change_password",
        method: "POST",
        headers: getHeaders(),
        body: { ...body },
      }),
      invalidatesTags: ["Auth"],
    }),

    updateProfile: builder.mutation({
      query: (body) => ({
        url: "/users/profile/update",
        method: "PUT",
        headers: getHeaders(),
        body,
      }),
      invalidatesTags: ["Auth"],
    }),

    deleteUser: builder.mutation({
      query: (id) => ({
        url: `user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Auth"],
    }),
  }),
});

export const {
  useIsAuthUserQuery,
  useGetUserProfileQuery,
  useGetCompanyNumberQuery,
  useLoginMutation,
  useRegisterUserMutation,
  useChangePasswordMutation,
  useForgotPasswordMutation,
  useValidateTokenMutation,
  useUpdateProfileMutation,
  useDeleteUserMutation,
} = authServerApi;
